import { render, staticRenderFns } from "./DeliveryFormDetails.vue?vue&type=template&id=1346d5d4&scoped=true&"
import script from "./DeliveryFormDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346d5d4",
  null
  
)

export default component.exports